import React from 'react';
import StreetViewModal from '../search/components/street_view_modal';
import PropertyLocationMap from './property_location_map';
import { Button } from 'react-bootstrap-5';

type Props = {
  fullscreen: boolean;
  property: any;
}

export default function PropertyMapView({ fullscreen, property }: Props) {
  return (
    <>
      <div
        className={`mx-0 gap-0 collapse show ${fullscreen ? 'rounded-3 overflow-hidden' : ''}`}
        id="property-details-maps"
      >
        <div className="row collapse-body">
          <div className="col px-0">
            <PropertyLocationMap property={property} />
          </div>

          <div
            className="col-6 col-lg-5 px-0 position-relative"
            id="property-street-view-wrapper"
            style={{ display: 'none' }}
          >
            <img
              className="w-100 object-fit-cover"
              src={property.streetviewUrl}
              style={{ height: 350 }}
              onError={(e) => {
                const target = e.target as HTMLElement;
                const wrapper = target.closest('#property-street-view-wrapper');
                if (wrapper) wrapper.setAttribute('style', 'display: none');
              }}
              onLoad={(e) => {
                const target = e.target as HTMLElement;
                const wrapper = target.closest('#property-street-view-wrapper');
                if (wrapper) wrapper.setAttribute('style', 'display: block');
              }}
            />
            <div className="bg-white position-absolute bottom-0 end-0 m-2">
              <StreetViewModal
                address={property.address}
                city={property.city}
                state={property.state}
                zip={property.zip}
              />
            </div>
          </div>
        </div>
      </div>

      <Button
        aria-controls="property-details-maps"
        aria-expanded="true"
        className="bg-white text-primary property-map-collapse-toggle ms-6"
        data-bs-target="#property-details-maps"
        data-bs-toggle="collapse"
        variant="link"
      >
        <i className="fa-solid fa-arrows-from-dotted-line"></i>
        <div className="show-collapsed">Expand Map</div>
        <div className="show-expanded">Hide Map</div>
      </Button>
    </>
  );
}
